export default function registerThingsToDoStore(Alpine) {
  Alpine.store('thingsToDo', {
    items: [],
    count: 0,
    seeded: false,
    loading: false,
    error: null,

    seed(data) {
      if (this.seeded) return;
      this.items = data.items;
      this.count = data.count;
      this.seeded = true;
      window.setInterval(() => {
        if (document.visibilityState === 'visible') this.refresh();
      }, 60000);
    },

    async refresh() {
      if (this.loading) return;
      this.loading = true;
      try {
        const response = await fetch('/things-to-do', {
          headers: { Accept: 'application/json' },
          cache: 'no-store',
        });
        const data = await response.json();
        if (!response.ok || !data.success || !Array.isArray(data.items)
          || !Number.isInteger(data.count) || data.count < 0) {
          throw new Error(data.message || 'Could not refresh your things to do.');
        }
        this.items = data.items;
        this.count = data.count;
        this.error = null;
      } catch (error) {
        this.error = 'Could not refresh your things to do. Showing the last loaded tasks.';
        console.warn(this.error, error);
      } finally {
        this.loading = false;
      }
    },
  });
}
